import type {
  GroupAnalysisType,
  TreesType,
  CostEstimationBasis,
} from '@/generated/types/navigator/types.gen';

export const GoogleEvents = {
  layerMenuOn: 'layer_menu_on',
  layerMenuOff: 'layer_menu_off',
  wildfireLayerOn: 'wildfire_layer_on',
  wildfireLayerOff: 'wildfire_layer_off',
  fuelHazardLayerOn: 'app_fuel_hazard_layer_on',
  fuelHazardLayerOff: 'app_fuel_hazard_layer_off',
  wildfireFilter: 'wildfire_filter',
  wildfireHelpTooltipOpened: 'wildfire_help_tooltip_opened',
  redFlagWarningFilter: 'red_flag_warning_filter',
  geolocatorOn: 'geolocator_on',
  geolocatorSuccess: 'geolocator_success',
  geolocatorPermissionError: 'geolocator_error_permission',
  geolocatorOtherError: 'geolocator_error_other',
  analysis: 'analysis',
  hazardTreesOn: 'hazard_trees_on',
  hazardTreesOff: 'hazard_trees_off',
  TreesViewDashboardPostfix: '_trees_view_dashboard',
  copy_span_name: 'copy_span_name',
  copy_span_url: 'copy_span_url',
  copy_pole_name: 'copy_pole_name',
  copy_pole_url: 'copy_pole_url',
  copy_hazard_tree_name: 'copy_hazard_tree_name',
  dashboardToMapEncroachment: 'dashboard_to_map_encroachment',
  dashboardToMapFallIn: 'dashboard_to_map_fallin',
  dashboardToMapClear: 'dashboard_to_map_clear',
  search: 'search',
  searchByAddress: 'search_by_address',
  filter: 'filter_by',
  openContextMenu: 'open_context_menu',
  openGmapsLink: 'open_gmaps_link',
  exportCSV: 'export_csv',
  exportXLS: 'export_xls',
  exportButtonClicked: 'export_button_clicked',
  exportFailed: 'export_failed',
  exportSuccessful: 'export_successful',
  worklogAddFieldInfo: 'worklog_add_field_info_clicked',
  worklogStatusAdded: 'worklog_status_added',
  worklogStatusWorkCompleted: 'worklog_status_work_completed',
  worklogStatusNoWorkNeeded: 'worklog_status_no_work_needed',
  worklogStatusWorkNeeded: 'worklog_status_work_needed',
  worklogDateFieldChanged: 'worklog_date_field_changed',
  worklogNotesWithContent: 'worklog_notes_with_content',
  worklogNotesWithContentChanged: 'worklog_notes_with_content_changed',
  worklogStatusEdited: 'worklog_status_edited',
  worklogDeleted: 'worklog_deleted',
  worktypeAnalysisOn: 'worktype_analysis_on',
  worktypeAnalysisOff: 'worktype_analysis_off',
  inspectMode: 'inspect_mode',
  spanClicked: 'span_clicked',
  priorityRatingFilter: 'filter_by_priority_rating',
  wildfirePriorityRatingFilter: 'filter_by_wildfire_priority_rating',
  fuelHazardRatingFilter: 'app_filter_by_fuel_hazard_rating',
  openNetworkGroupSummaryTab: 'app_open_network_group_summary_tab',
  openNetworkGroupSpansTab: 'app_open_network_group_spans_tab',
  riskMetricsHelpClicked: 'app_risk_metrics_help_clicked',
  spreadPotentialViewed: 'app_spread_potential_viewed',
  networkGroupFuelsViewed: 'app_network_group_fuels_viewed',
  spanFuelsViewed: 'app_span_fuels_viewed',
  encroachmentRatingFilter: 'filter_by_encroachment_rating',
  encroachmentTypeFilter: 'filter_by_encroachment_type',
  hazardTreesToggleFilter: 'filter_by_hazard_trees',
  strikeTreesToggleFilter: 'filter_by_strike_trees',
  criticalTreesToggleFilter: 'filter_by_critical_trees',
  tagsFilter: 'filter_by_tag',
  speciesFilter: 'filter_by_species',
  distributionFilter: 'filter_by_distribution',
  transmissionFilter: 'filter_by_transmission',
  distributionPhasingFilter: 'filter_by_phasing',
  transmissionPhasingFilter: 'filter_by_phasing',
  noResultsFilter: 'filter_no_results',
  level2Clicked: 'level2_clicked',
  groupItemClicked: 'group_item_clicked',
  selected: 'selected',
  groupBy: 'group_by',
  filterByGroup: 'filter_by_group',
  scanSelectorOpened: 'scan_selector_opened',
  scanSelectorChanged: 'scan_selector_changed',
  releaseSelectorOpened: 'release_selector_opened',
  releaseSelectorChanged: 'release_selector_changed',
  programs: {
    // Table-level events
    cellEdited: 'program_table_cell_edited',
    stateChanged: 'program_table',
    scopeUpdated: 'program_table_scope_updated',
    headlineStatsYearChanged: 'program_table_headline_stats_year_changed',
    columnGroupExpansion: 'program_table_column_group_expansion',
    costEstimationsChanged: 'program_table_cost_estimations_changed',
  },
  // Program and scenario events
  program: {
    created: 'app_program_created',
    deleted: 'app_program_deleted',
    costEstimationsChanged: 'app_program_cost_estimations_changed',
    costEstimationBasisSet: 'app_program_cost_estimation_basis_set',
  },
  scenario: {
    created: 'app_scenario_created',
    duplicated: 'app_scenario_duplicated',
    edited: 'app_scenario_edited',
    published: 'app_scenario_published',
    deleted: 'app_scenario_deleted',
    nameChanged: 'app_scenario_name_changed',
    descriptionChanged: 'app_scenario_description_changed',
    scopeYearChanged: 'app_scenario_scope_year_changed',
  },
  reliabilityImpactMetrics: {
    reliabilityDataConfigSaved: 'app_reliability_data_config_saved',
    programsListReliabilityTooltipClicked:
      'app_programs_list_reliability_risk_tooltip_clicked',
    scenariosListReliabilityTooltipClicked:
      'app_scenarios_list_reliability_tooltip_clicked',
    scenarioDetailsRiskInScopeTooltipClicked:
      'app_scenario_details_risk_in_scope_tooltip_clicked',
  },
  worklogActivity: {
    bulkAdd: {
      completed: 'worklog_activity_bulk_add_work_completed',
      no_work_needed: 'worklog_activity_bulk_add_no_work_needed',
      work_needed: 'worklog_activity_bulk_add_work_needed',
    },
  },
  projects: {
    creation: {
      clickedAddToProject: 'projects_add_to_project_clicked',
      newProject: 'projects_create_new_project',
      newProjectSaved: 'projects_new_project_saved',
      clickedCreateProjectFromOverview:
        'projects_create_project_clicked_overview',
      clickedCreateProjectFromEntry: 'projects_create_project_clicked_entry',
      clickedCreateNextStep: 'projects_create_next_step',
    },
    entry: {
      directShortcut: 'projects_entry_direct_shortcut',
      allProjects: 'projects_entry_all_projects',
      spanDetailAffordance: 'projects_entry_span_detail_affordance',
      mapListAffordance: 'projects_entry_map_list_affordance',
      toastLink: 'projects_entry_toast_link',
    },
    engagement: {
      spanClickFromMap: 'projects_engagement_span_click_from_map',
      spanClickMapList: 'projects_engagement_span_click_map_list',
      analysisChange: 'projects_engagement_analysis_change',
      copyUrl: 'projects_engagement_copy_url',
      export: 'projects_engagement_export',
    },
    adding: {
      bulk: 'projects_bulk_add_to_project',
      individual: 'projects_individual_add_to_project',
    },
    removing: {
      span: 'projects_remove_span_from_project',
    },
    managing: {
      delete: 'projects_delete_project',
      edit: 'projects_edit_project',
    },
    clickOut: {
      addToProject: 'projects_click_out_add_to_project',
      projectDetails: 'projects_click_out_project_details',
      tooManySpansRevert: 'projects_click_out_too_many_spans_revert',
      tooManySpansContinue: 'projects_click_out_too_many_spans_continue',
    },
  },
  redFlagWarning: {
    card: {
      cardOpened: 'red_flag_warning_card_opened',
      showAffectedSpans: 'red_flag_warning_card_show_affected_spans',
      warningInformation: 'red_flag_warning_card_warning_information',
    },
    map: {
      mapPolygonModalOpened: 'red_flag_warning_map_polygon_modal_opened',
      mapPolygonModalClosed: 'red_flag_warning_map_polygon_modal_closed',
    },
  },
} as const;

export const getGoogleEventForTreeType = (
  treeType: TreesType,
  eventPostfix: string
) => `${treeType}_${eventPostfix}`;

export const getGoogleEventForAnalysis = (
  analysisType: GroupAnalysisType,
  event: string,
  isPostFix?: boolean
) =>
  isPostFix
    ? `${analysisType.toLocaleLowerCase()}_${event}`
    : `${event}_${analysisType.toLocaleLowerCase()}_analysis`;

export const getGoogleEventForProgramCostEstimationBasisChange = (
  basis: CostEstimationBasis
) => `${GoogleEvents.program.costEstimationBasisSet}_${basis}`;
